import { ISeparateConfig } from './typings';

const config: ISeparateConfig = {
  type: 'vertical',
  displayMode: undefined,
};

export default config;
